/* DOSALMA — interacciones y animaciones (vanilla JS, sin librerías) */
(function () {
  if (window.__dmInit) return;
  window.__dmInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  /* ---------- Reveal al entrar en pantalla ---------- */
  var revealIO = null;
  function initReveal() {
    var els = document.querySelectorAll('.dm-reveal:not([data-dm-rv])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('dm-in'); el.setAttribute('data-dm-rv', '1'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('dm-in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { el.setAttribute('data-dm-rv', '1'); revealIO.observe(el); });
  }

  /* ---------- Cabecera ---------- */
  function initHeader() {
    var header = document.querySelector('[data-dm-header]');
    if (!header || header.dataset.dmInit) return;
    header.dataset.dmInit = '1';
    var burger = header.querySelector('[data-dm-burger]');
    var drawer = header.querySelector('[data-dm-drawer]');
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var sBtn = header.querySelector('[data-dm-search-toggle]');
    var sBox = header.querySelector('[data-dm-search]');
    if (sBtn && sBox) {
      var sIn = sBox.querySelector('[data-dm-search-input]');
      var sClose = function () { sBox.hidden = true; sBtn.setAttribute('aria-expanded', 'false'); };
      sBtn.addEventListener('click', function () {
        var open = sBox.hidden;
        sBox.hidden = !open;
        sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && sIn) sIn.focus();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sClose(); });
    }
    if (burger && drawer) {
      var close = function () { burger.setAttribute('aria-expanded', 'false'); drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') !== 'true';
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        drawer.classList.toggle('is-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      });
      drawer.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
      window.addEventListener('resize', function () { if (window.innerWidth > 989) close(); });
    }
  }

  /* ---------- Héroe: foco de luz que sigue al cursor + chispas ---------- */
  function initHero() {
    document.querySelectorAll('[data-dm-hero]').forEach(function (hero) {
      if (hero.dataset.dmInit) return;
      hero.dataset.dmInit = '1';
      var spot = hero.querySelector('[data-dm-spot]');
      var tx = 76, ty = 55, cx = 76, cy = 55, raf = null, active = false;
      var set = function () {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        hero.style.setProperty('--mx', cx.toFixed(2) + '%');
        hero.style.setProperty('--my', cy.toFixed(2) + '%');
        if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) raf = requestAnimationFrame(set); else raf = null;
      };
      if (spot && !isTouch && !reduceMotion) {
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          tx = ((e.clientX - r.left) / r.width) * 100;
          ty = ((e.clientY - r.top) / r.height) * 100;
          if (!raf) raf = requestAnimationFrame(set);
        });
        hero.addEventListener('mouseleave', function () { tx = 76; ty = 55; if (!raf) raf = requestAnimationFrame(set); });
      } else if (spot) {
        hero.style.setProperty('--mx', window.innerWidth < 750 ? '50%' : '76%');
        hero.style.setProperty('--my', window.innerWidth < 750 ? '70%' : '55%');
      }

      /* chispas doradas */
      var canvas = hero.querySelector('[data-dm-sparks]');
      if (!canvas || hero.dataset.sparks !== 'true' || reduceMotion || window.innerWidth < 990) return;
      var ctx = canvas.getContext('2d');
      var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
      var mobile = window.innerWidth < 750;
      var N = mobile ? 18 : 42, parts = [], visible = true, running = false;
      var resize = function () {
        W = hero.clientWidth; H = hero.clientHeight;
        canvas.width = W * dpr; canvas.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      };
      var spawn = function (p, initial) {
        p.x = Math.random() * W;
        p.y = initial ? Math.random() * H : H + 10;
        p.r = 0.6 + Math.random() * 1.9;
        p.vy = 0.12 + Math.random() * 0.4;
        p.vx = (Math.random() - 0.5) * 0.18;
        p.a = 0.25 + Math.random() * 0.6;
        p.ph = Math.random() * Math.PI * 2;
        p.sp = 0.6 + Math.random() * 1.6;
        return p;
      };
      resize();
      for (var i = 0; i < N; i++) parts.push(spawn({}, true));
      var t0 = 0;
      var frame = function (t) {
        if (!visible) { running = false; return; }
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          p.y -= p.vy; p.x += p.vx + Math.sin(t / 1400 + p.ph) * 0.12;
          if (p.y < -10) spawn(p, false);
          var tw = 0.55 + 0.45 * Math.sin(t / 1000 * p.sp + p.ph);
          var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 5);
          g.addColorStop(0, 'rgba(255,226,160,' + (p.a * tw).toFixed(3) + ')');
          g.addColorStop(1, 'rgba(255,200,120,0)');
          ctx.fillStyle = g;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 5, 0, 6.2832); ctx.fill();
        }
        requestAnimationFrame(frame);
      };
      var start = function () { if (!running && visible) { running = true; requestAnimationFrame(frame); } };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); }, { threshold: 0.02 }).observe(hero);
      }
      window.addEventListener('resize', resize);
      start();
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnetic() {
    if (isTouch || reduceMotion) return;
    document.querySelectorAll('[data-dm-magnetic]:not([data-dm-mg])').forEach(function (btn) {
      btn.setAttribute('data-dm-mg', '1');
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / r.width;
        var y = (e.clientY - (r.top + r.height / 2)) / r.height;
        btn.style.setProperty('--tx', (x * 10).toFixed(1) + 'px');
        btn.style.setProperty('--ty', (y * 8).toFixed(1) + 'px');
      });
      btn.addEventListener('mouseleave', function () { btn.style.setProperty('--tx', '0px'); btn.style.setProperty('--ty', '0px'); });
    });
  }

  /* ---------- Parallax suave (scroll) ---------- */
  var parallaxEls = [];
  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-dm-parallax]'));
  }
  var ticking = false;
  function runScroll() {
    ticking = false;
    var vh = window.innerHeight;
    if (!reduceMotion && window.innerWidth > 989) {
      parallaxEls.forEach(function (el) {
        var host = el.closest('.shopify-section') || el.parentElement;
        var r = host.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-dm-parallax')) || 0.15;
        var off = (r.top + r.height / 2 - vh / 2) * -k;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    /* frase que se ilumina palabra a palabra */
    document.querySelectorAll('[data-dm-words]').forEach(function (p) {
      var words = p._dmWords || (p._dmWords = Array.prototype.slice.call(p.querySelectorAll('.dm-w')));
      var r = p.getBoundingClientRect();
      var start = vh * 0.86, end = vh * 0.34;
      var prog = clamp((start - r.top) / (start - end + r.height * 0.6), 0, 1);
      if (reduceMotion) prog = 1;
      var lit = Math.round(prog * words.length);
      for (var i = 0; i < words.length; i++) {
        var on = i < lit;
        if (on !== words[i].classList.contains('is-lit')) words[i].classList.toggle('is-lit', on);
      }
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }

  /* ---------- Qué hay en la caja: puntos ↔ lista ---------- */
  function initBox() {
    document.querySelectorAll('.dm-box').forEach(function (box) {
      if (box.dataset.dmInit) return;
      box.dataset.dmInit = '1';
      var items = box.querySelectorAll('.dm-box__item');
      var pins = box.querySelectorAll('.dm-pin');
      var set = function (i) {
        items.forEach(function (el) { el.classList.toggle('is-active', el.dataset.i === i); });
        pins.forEach(function (el) { el.classList.toggle('is-active', el.dataset.i === i); });
      };
      var clear = function () { set(''); };
      items.forEach(function (el) {
        el.addEventListener('mouseenter', function () { set(el.dataset.i); });
        el.addEventListener('focus', function () { set(el.dataset.i); });
        el.addEventListener('mouseleave', clear);
        el.addEventListener('blur', clear);
        el.addEventListener('click', function () { set(el.dataset.i); });
      });
      pins.forEach(function (el) {
        el.addEventListener('mouseenter', function () { set(el.dataset.i); });
        el.addEventListener('focus', function () { set(el.dataset.i); });
        el.addEventListener('click', function () { set(el.dataset.i); });
        el.addEventListener('mouseleave', clear);
        el.addEventListener('blur', clear);
      });
      /* recorrido automático hasta que el visitante interactúa */
      if (!reduceMotion) {
        var idx = 0, timer = null, userTouched = false;
        var stage = box.querySelector('[data-dm-box-stage]');
        var tick = function () { if (userTouched) return; set(String((idx % items.length) + 1)); idx++; };
        var startAuto = function () { if (timer || userTouched) return; timer = setInterval(tick, 2600); tick(); };
        var stopAuto = function () { clearInterval(timer); timer = null; };
        box.addEventListener('mouseenter', function () { userTouched = true; stopAuto(); });
        box.addEventListener('touchstart', function () { userTouched = true; stopAuto(); }, { passive: true });
        if ('IntersectionObserver' in window && stage) {
          new IntersectionObserver(function (es) {
            if (es[0].isIntersecting) startAuto(); else { stopAuto(); if (!userTouched) clear(); }
          }, { threshold: 0.45 }).observe(stage);
        }
      }
    });
  }

  /* ---------- Cifras: cuenta animada ---------- */
  function initCounts() {
    var els = document.querySelectorAll('[data-dm-count]:not([data-dm-ct])');
    els.forEach(function (el) {
      el.setAttribute('data-dm-ct', '1');
      var target = parseFloat(el.getAttribute('data-dm-count'));
      if (isNaN(target)) return;
      var text = el.textContent;
      var dec = (String(target).split('.')[1] || '').length;
      var run = function () {
        if (reduceMotion) { el.textContent = text; return; }
        var t0 = null, dur = 1700;
        var step = function (t) {
          if (!t0) t0 = t;
          var p = clamp((t - t0) / dur, 0, 1);
          var e = 1 - Math.pow(1 - p, 4);
          el.textContent = (target * e).toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(step); else el.textContent = text;
        };
        requestAnimationFrame(step);
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { io.disconnect(); run(); }
        }, { threshold: 0.6 });
        io.observe(el);
      } else { el.textContent = text; }
    });
  }

  /* ---------- Página de producto ---------- */
  function money(el, v) { if (el) el.textContent = v; }
  function refreshCartBubble() {
    return fetch((window.routes && window.routes.root_url ? window.routes.root_url : '/') + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-icon-bubble'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section') || doc.body;
        var target = document.getElementById('cart-icon-bubble');
        if (target) target.innerHTML = inner.innerHTML;
      }).catch(function () {});
  }
  var toastTimer = null;
  function showToast(title, name) {
    var t = document.querySelector('.dm-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'dm-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<div class="dm-toast__t"><i>✓</i><span></span></div><p class="dm-toast__p"></p><div class="dm-toast__a"><a class="dm-btn dm-btn--ghost" data-c></a><a class="dm-btn dm-btn--gold" data-k></a></div>';
      document.body.appendChild(t);
      t.querySelector('[data-c]').textContent = 'Ver carrito';
      t.querySelector('[data-k]').textContent = 'Finalizar compra';
      t.querySelector('[data-c]').href = (window.routes && window.routes.cart_url) || '/cart';
      t.querySelector('[data-k]').href = '/checkout';
    }
    t.querySelector('.dm-toast__t span').textContent = title;
    t.querySelector('.dm-toast__p').textContent = name;
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 6000);
  }

  function initPDP() {
    document.querySelectorAll('[data-dm-pdp]').forEach(function (root) {
      if (root.dataset.dmInit) return;
      root.dataset.dmInit = '1';

      /* galería */
      var main = root.querySelector('[data-dm-main]');
      var mainImg = root.querySelector('[data-dm-main-img]');
      var thumbs = root.querySelectorAll('[data-dm-thumb]');
      var swapTo = function (btn) {
        if (!mainImg) return;
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        main.classList.add('is-swap');
        setTimeout(function () {
          mainImg.src = btn.dataset.full;
          mainImg.srcset = btn.dataset.src700 + ' 700w, ' + btn.dataset.src1100 + ' 1100w, ' + btn.dataset.src1600 + ' 1600w';
          mainImg.alt = btn.dataset.alt || '';
          main.classList.remove('is-swap');
        }, 200);
      };
      thumbs.forEach(function (b) { b.addEventListener('click', function () { swapTo(b); }); });
      if (main && !isTouch && !reduceMotion) {
        main.addEventListener('mouseenter', function () { main.classList.add('is-zoom'); });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          main.style.setProperty('--zx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
          main.style.setProperty('--zy', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
        });
      }

      /* variantes */
      var form = root.querySelector('[data-dm-form]');
      var dataEl = root.querySelector('[data-dm-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var idInput = root.querySelector('[data-dm-variant-id]');
      var priceEl = root.querySelector('[data-dm-price]');
      var compareEl = root.querySelector('[data-dm-compare]');
      var stickyPrice = root.querySelector('[data-dm-price-sticky]');
      var addBtn = root.querySelector('[data-dm-add]');
      var addLabel = root.querySelector('[data-dm-add-label]');
      var baseLabel = addLabel ? addLabel.textContent : 'Añadir al carrito';
      var onVariant = function () {
        var fs = root.querySelectorAll('.dm-opt');
        if (!fs.length) return;
        var chosen = [];
        fs.forEach(function (f) { var c = f.querySelector('input:checked'); chosen.push(c ? c.value : null); });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) { if (addBtn) { addBtn.disabled = true; addLabel.textContent = 'No disponible'; } return; }
        if (idInput) idInput.value = v.id;
        money(priceEl, v.price); money(stickyPrice, v.price);
        if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.textContent = v.compare; }
        if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? baseLabel : 'Agotado'; }
        if (v.image) { var th = root.querySelector('[data-dm-thumb][data-media-id="' + v.image + '"]'); if (th) swapTo(th); }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
      };
      root.querySelectorAll('.dm-opt input').forEach(function (i) { i.addEventListener('change', onVariant); });

      /* cantidad */
      var qty = root.querySelector('[data-dm-qty] input');
      root.querySelectorAll('[data-dm-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.dataset.dmStep, 10));
        });
      });

      /* añadir al carrito sin recargar */
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch || !addBtn || addBtn.disabled) return;
          e.preventDefault();
          addBtn.classList.add('is-loading');
          var fd = new FormData(form);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              addBtn.classList.remove('is-loading');
              if (!res.ok) { showToast('No se ha podido añadir', res.j.description || res.j.message || 'Inténtalo de nuevo.'); return; }
              refreshCartBubble();
              showToast('Añadido al carrito', res.j.product_title || res.j.title || '');
            }).catch(function () { addBtn.classList.remove('is-loading'); form.submit(); });
        });
      }

      /* barra fija móvil */
      var sticky = root.querySelector('[data-dm-sticky]');
      var stickyAdd = root.querySelector('[data-dm-sticky-add]');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var out = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', out);
        }, { threshold: 0 }).observe(addBtn);
        if (stickyAdd) stickyAdd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
      }
    });
  }

  function initAll() {
    initReveal();
    initHeader();
    initHero();
    initMagnetic();
    initBox();
    initCounts();
    initPDP();
    collectParallax();
    runScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
